import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { priceDownService, WeeklyPriceComparison } from '@/services/priceDownService';
import { subWeeks, format } from 'date-fns';

export const usePriceDownData = (initialStartDate?: Date, initialEndDate?: Date) => {
  const [dateRange, setDateRange] = useState({
    startDate: initialStartDate || subWeeks(new Date(), 4), // Default to 4 weeks ago
    endDate: initialEndDate || new Date()
  });

  const {
    data: weeklyComparisons,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['price-down-data', format(dateRange.startDate, 'yyyy-MM-dd'), format(dateRange.endDate, 'yyyy-MM-dd')],
    queryFn: async (): Promise<WeeklyPriceComparison[]> => {
      const startDateStr = format(dateRange.startDate, 'yyyy-MM-dd');
      const endDateStr = format(dateRange.endDate, 'yyyy-MM-dd');

      const [chipchipPrices, competitorPrices] = await Promise.all([
        priceDownService.fetchChipChipPrices(startDateStr, endDateStr),
        priceDownService.fetchCompetitorPrices(startDateStr, endDateStr)
      ]);

      return priceDownService.processWeeklyPriceComparison(
        chipchipPrices,
        competitorPrices,
        dateRange.startDate,
        dateRange.endDate
      );
    },
    enabled: !!(dateRange.startDate && dateRange.endDate)
  });

  const updateDateRange = (startDate: Date, endDate: Date) => {
    setDateRange({ startDate, endDate });
  };

  return {
    weeklyComparisons: weeklyComparisons || [],
    isLoading,
    error,
    dateRange,
    updateDateRange,
    refetch
  };
};